import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, Grid, IconButton, Input, InputAdornment } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircleOutline';

import { PublicUserProfile } from 'api';
import { Alert, UserAvatar } from 'components';
import { getFullName } from 'helpers';

interface IProps extends WithStyles<typeof styles> {
  user: PublicUserProfile;
  removeKey: string;
  confirmKey: string;
  canRemove: boolean;
  onRemove: (user: PublicUserProfile) => void;
}

const styles = (theme: Theme) =>
  createStyles({
    positionStart: {
      marginLeft: theme.spacing(1),
      marginRight: 0,
    },
  });

const RemoveUser: FC<IProps> = props => {
  const { classes, user, canRemove, onRemove, removeKey, confirmKey } = props;
  const [deleteOpen, setDeleteOpen] = useState(false);
  const { t } = useTranslation();

  function toggleConfirm() {
    setDeleteOpen(!deleteOpen);
  }

  function renderAlert() {
    return (
      <Alert
        open={deleteOpen}
        onConfirm={() => {
          toggleConfirm();
          onRemove(user);
        }}
        onCancel={toggleConfirm}
        message={t(removeKey)}
        confirm={t(confirmKey)}
      />
    );
  }

  return (
    <Fragment>
      <Grid container alignItems="center">
        <Grid item xs>
          <FormControl fullWidth margin="normal">
            <Input
              disabled
              disableUnderline
              value={getFullName(user)}
              startAdornment={
                <InputAdornment classes={classes} position="start">
                  <UserAvatar link size={30} user={user} />
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>
        {canRemove && (
          <Grid item>
            <IconButton onClick={toggleConfirm}>
              <RemoveCircleIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>
      {renderAlert()}
    </Fragment>
  );
};

export default withStyles(styles)(RemoveUser);
